module.exports = {"340823100":"枞阳镇","340823101":"欧山镇","340823102":"汤沟镇","340823103":"老洲镇","340823104":"陈瑶湖镇","340823105":"周潭镇","340823106":"横埠镇","340823107":"项铺镇","340823108":"钱桥镇","340823109":"麒麟镇","340823110":"义津镇","340823111":"浮山镇","340823112":"会宫镇","340823113":"官埠桥镇","340823200":"铁铜乡","340823201":"凤仪乡","340823202":"长沙乡","340823203":"钱铺乡","340823204":"金社乡","340823205":"白梅乡","340823206":"白湖乡","340823207":"雨坛乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/340823.json
// module id = 1201
// module chunks = 0